// Charge la base commune
import './common.js'

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // responsive tabs
  $('.resp-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })
})
